export const environment = {
  production: false,
  apiUrl: 'https://cafe.renatobonfim.com/api'
  //apiUrl: 'http://localhost:8090/api'
};
